<template>
  <div class="container">
    <h2>儲值設定</h2>
    <div class="toggle-box">
      <p>儲值開關</p>
      <div class="button-item">
        <a
          class="button-item-on btn"
          @click="changeStored"
          href="#"
          v-cloak
          :class="{ active: isActive }"
        >
          {{ isActive ? 'ON' : 'OFF' }}
        </a>
      </div>
    </div>
    <div class="search-box">
      <div class="form-group form-inline">
        <label for="driverCode">搜尋呼號</label>
        <input
          type="text"
          v-model="driverNumber"
          class="form-control"
          id="driverCode"
          placeholder="請輸入呼號可快速儲值或退款"
        />
      </div>
      <a href="#" class="btn btn-primary" @click="search">查詢</a>
    </div>
    <div class="hint-box">
      <h3>*小提示：</h3>
      <p>請記得去「司機資料」做扣款設定</p>
      <p>單次儲值金額，上限為 5000 元</p>
    </div>
    <StoredModal :driverNumber="driverNumber" :record="record"></StoredModal>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'
import { cookies } from '@/utils/cookies'
import StoredModal from '@/components/stored/StoredModal'

export default {
  data() {
    return {
      record: [],
      driverNumber: '',
      isActive: true,
      teamCodeCookie: cookies.get('GladTeamCode'),
    }
  },
  components: {
    StoredModal,
  },
  methods: {
    getStoredStatus() {
      API.get(`store_value/option`).then((res) => {
        this.isActive = res.result.option
      })
    },
    changeStored() {
      this.isActive = !this.isActive
      const data = {
        option: this.isActive,
      }
      API.put(`${API.getAPIUrl}store_value/option`, data)
        .then(() => {
          this.getStoredStatus()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    search() {
      if (this.driverNumber === '') {
        alert('請輸入正確資料')
        return
      }
      API.get(`store_value/${this.driverNumber}`)
        .then((res) => {
          this.record = res.result
          $('#driverModal').modal('show')
          console.log(res)
        })
        .catch((error) => {
          alert(error.data.error.message)
        })
    },
  },
  created() {
    this.getStoredStatus()
  },
}
</script>

<style scoped lang="scss">
.active {
  background-color: red;
}
.container {
  padding: 0 15px;
}
h2 {
  font-size: 36px;
  margin: 36px 0;
  font-weight: bold;
  color: black;
}
.toggle-box {
  display: flex;
  align-items: center;
  p {
    font-size: 21px;
    margin: 0;
  }
}
.search-box {
  display: flex;
  align-items: center;
  margin-top: 50px;
  label {
    font-weight: normal;
    font-size: 20px;
    margin-bottom: 0px;
    vertical-align: middle;
  }
  input {
    border-radius: 5px;
    width: 210px;
  }
}
.form-group {
  margin-bottom: 0;
  input {
    margin: 0 20px;
  }
}
a {
  margin: 0;
}
.button-item {
  display: flex;
  margin: 0 20px;
  .active {
    background-color: #26b99a;
    color: white;
  }
  a {
    text-align: center;
    width: 54px;
    font-size: 14px;
    padding: 5px;
    display: block;
  }
  &-on {
    margin: 0;
    background-color: rgb(239, 84, 84);
    color: white;
  }
}
.hint-box {
  h3 {
    font-size: 16px;
    color: rgb(239, 84, 84);
  }
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/stored/StoredItem.vue